import type { NavigateOptions } from 'react-router-dom';

export function isWorkOrderDetailPath(pathname: string): boolean {
  return /^\/workorders\/[^/]+$/.test(pathname);
}

/** The work order a detail path shows, or null on any other page. */
export function workOrderIdFromPath(pathname: string): string | null {
  return /^\/workorders\/([^/]+)$/.exec(pathname)?.[1] ?? null;
}

/**
 * Navigate away from the work-order detail page.
 *
 * Leaving a fully-rendered WorkOrderDetailContent makes React 19's concurrent
 * transition render (react-router v7 wraps navigation in startTransition) get
 * stuck — it starts but never commits, so the router subtree freezes on the old
 * page while the URL changes. Forcing a synchronous commit via `flushSync`
 * bypasses the stuck transition lane and keeps navigation as a normal SPA
 * transition (no full-page reload). Root cause: issue #842.
 */
export function navigateAwayFromWorkOrderDetail(
  currentPathname: string,
  target: string,
  spaNavigate: (to: string, options?: NavigateOptions) => void,
): void {
  if (isWorkOrderDetailPath(currentPathname) && target !== currentPathname) {
    spaNavigate(target, { flushSync: true });
    return;
  }

  spaNavigate(target);
}
